import { styled } from "@mui/material";

export const ContentWrapper = styled("div")(({ theme }) => ({
  
  background: 'linear-gradient(45deg, #34145B 10%, #0B071C 90%)',
  //backgroundColor: theme.palette.primary.light,
  minHeight: "100vh",
}));
